import React from 'react';
import styled, { keyframes } from 'styled-components';
import { IIcons } from '../interfaces/icons';
import { getColorHelper } from '../utils/getColorHelpers';
import { defaultTheme } from '../styles/theme/default';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.svg`
  animation: ${rotate} 0.6s linear infinite;
`;

export function Loading({
  fillColor = 'white',
  colorWeight,
  size = '12',
}: IIcons) {
  return (
    <Spinner height={size} width={size} viewBox="0 0 512 512">
      <g fill={getColorHelper(fillColor, colorWeight)}>
        <path d="M83.9 356.1c-7.5-12.1-23-16.7-35.1-9.2s-16.7 23-9.2 35.1c4.6 8.1 13.2 12.7 22.4 12.7 4.6 0 8.6-1.2 13.2-3.5 11.6-6.9 15.6-23 8.7-35.1zM256.6 455.1c-14.4 0-25.9 11.5-25.9 25.9s11.5 25.9 25.9 25.9c14.4 0 25.9-11.5 25.9-25.9s-11.5-25.9-25.9-25.9zM428.7 355.6c-6.9 12.1-2.9 28.2 9.8 35.1 4 2.3 8.6 3.5 13.2 3.5 8.6 0 17.8-4.6 22.4-13.2 6.9-12.1 2.9-28.2-9.2-35.1-13.2-7-29.3-3-36.2 9.7zM157 428.7c-12.7-6.9-28.2-2.9-35.1 9.8-6.9 12.7-2.9 28.2 9.2 35.1 4 2.3 8.6 3.5 13.2 3.5 8.6 0 17.8-4.6 22.4-13.2 7-12.2 2.4-27.8-9.7-35.2zM455.1 256c0 14.4 11.5 25.9 25.9 25.9 14.4 0 25.9-11.5 25.9-25.9s-11.5-25.9-25.9-25.9c-14.3 0-25.9 11.5-25.9 25.9zM451.1 169.1c4.6 0 8.6-1.2 13.2-3.5 12.1-7.5 16.7-23 9.2-35.7-7.5-12.1-23-16.7-35.1-9.2-12.1 6.9-16.7 23-9.2 35.1 4.1 8.7 12.7 13.3 21.9 13.3zM355.6 83.3c4 2.3 8.6 3.5 13.2 3.5 9.2 0 17.8-4.6 22.4-12.7 7.5-12.1 2.9-28.2-9.2-35.1-12.1-7.5-28.2-2.9-35.1 9.2-8 12.1-3.4 28.2 8.7 35.1zM391.3 437.9c-7.5-12.7-23-16.7-35.1-9.2-12.1 7.5-16.7 23-9.2 35.7 4.6 8.1 13.8 12.7 22.4 12.7 4.6 0 8.6-1.2 13.2-3.5 11.5-7.5 16.1-23.6 8.7-35.7zM31 281.9c14.4 0 25.9-11.5 25.9-25.9 0-109.9 89.2-199.1 199.1-199.1 14.4 0 25.9-11.5 25.9-25.9S270.4 5.1 256 5.1C117.9 5.1 5.1 117.9 5.1 256c0 14.4 11.5 25.9 25.9 25.9z" />
      </g>
    </Spinner>
  );
}
